import { render, staticRenderFns } from "./fccSubTipoSir2.vue?vue&type=template&id=5969622b"
import script from "./fccSubTipoSir2.vue?vue&type=script&lang=js"
export * from "./fccSubTipoSir2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports